import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import { common } from "../../i18n";
import { GoalLock } from "../../models/GoalSetting";
import { GOAL_SETTING_MIN_PLAN } from "../../constants/app-config";
import { isAddGoalDisabled } from "../../contexts/useGoalLimit";

// the disabled Add Goal buttons point here through aria-describedby
export const GOAL_LOCK_NOTE_ID = "goal-lock-note";

export const GoalLockNote = ({ lock }: { lock: GoalLock }) => {
  const { t } = useTranslation([common], { nsMode: "fallback" });
  if (!isAddGoalDisabled(lock)) return null;

  const full = { used: lock.used, limit: lock.limit, plan: lock.planName };
  // over the cap one delete is not enough; name how many free a slot
  const overBy = lock.limit === null ? 0 : lock.used - lock.limit;
  const message =
    lock.state === "locked"
      ? t("Goal-Lock-Locked", { minPlan: GOAL_SETTING_MIN_PLAN, plan: lock.planName })
      : overBy > 0
        ? t("Goal-Lock-Over", { ...full, toDelete: overBy + 1 })
        : t("Goal-Lock-Full", full);

  return (
    <Box
      id={GOAL_LOCK_NOTE_ID}
      role="status"
      display="flex"
      alignItems="center"
      gap={1.5}
      bgcolor="var(--gray3)"
      p="12px 16px"
      borderRadius="8px"
      width="100%"
      boxSizing="border-box"
      alignSelf="stretch"
    >
      <InfoOutlinedIcon color="primary" />
      <Typography variant="body1" color="var(--dark)">
        <Typography component="span" variant="h4" color="primary" mr={1}>
          {t("Note")}:
        </Typography>
        {message}
      </Typography>
    </Box>
  );
};
